(function () {
  var drawer = document.getElementById("quote-drawer");
  var title = document.getElementById("quote-title");
  var productText = document.getElementById("quote-product");
  var triggers = document.querySelectorAll(".quote-trigger");
  var closers = document.querySelectorAll(".quote-close, .quote-close-link");

  function getContactNavLabel() {
    var lang = (document.documentElement.getAttribute("lang") || "").toLowerCase();
    if (lang.indexOf("zh") === 0) return "联系我们";
    if (lang.indexOf("en") === 0) return "Contact";
    return "お問い合わせ";
  }

  function ensureContactNavLink() {
    var nav = document.querySelector(".nav-links");
    if (!nav || nav.querySelector('a[href="#contact"]')) return;
    var link = document.createElement("a");
    link.className = "nav-contact-link";
    link.href = "#contact";
    link.textContent = getContactNavLabel();
    nav.appendChild(link);
  }

  ensureContactNavLink();

  function openDrawer(productName) {
    if (!drawer) return;
    var fallbackProduct = drawer.getAttribute("data-fallback-product") || "Product";
    var selectedTemplate = drawer.getAttribute("data-selected-template") || "Selected {product}.";
    if (title) title.textContent = drawer.getAttribute("data-moq-title") || title.textContent;
    if (productText) productText.textContent = selectedTemplate.replace("{product}", productName || fallbackProduct);
    drawer.classList.add("is-open");
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", function () {
      openDrawer(trigger.getAttribute("data-product") || "商品");
    });
  });

  closers.forEach(function (closer) {
    closer.addEventListener("click", closeDrawer);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") closeDrawer();
  });

  function clampMoqInput(input) {
    var min = Number(input.getAttribute("min") || "10");
    var value = Number(input.value || "0");
    if (!value || value < min) input.value = String(min);
  }

  document.querySelectorAll(".yzl-qty-input, .yzl-cart-qty-input").forEach(function (input) {
    input.addEventListener("change", function () {
      clampMoqInput(input);
    });
    input.addEventListener("blur", function () {
      clampMoqInput(input);
    });
  });

  document.querySelectorAll(".yzl-product-form").forEach(function (form) {
    form.addEventListener("submit", function () {
      form.querySelectorAll(".yzl-qty-input").forEach(clampMoqInput);
    });
  });

  document.querySelectorAll(".product-gallery").forEach(function (gallery) {
    var mainImage = gallery.querySelector(".product-main-media img");
    var thumbs = gallery.querySelectorAll(".product-thumb-grid button");
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var nextSrc = thumb.getAttribute("data-gallery-src");
        var nextAlt = thumb.getAttribute("data-gallery-alt");
        if (!nextSrc) return;
        mainImage.src = nextSrc;
        if (nextAlt) mainImage.alt = nextAlt;
        thumbs.forEach(function (item) {
          item.classList.remove("is-active");
        });
        thumb.classList.add("is-active");
      });
    });
  });

  document.querySelectorAll(".cart-form").forEach(function (form) {
    form.addEventListener("submit", function (event) {
      var checkoutButton = event.submitter && event.submitter.name === "checkout";
      var hasError = false;
      form.querySelectorAll(".yzl-cart-qty-input").forEach(function (input) {
        clampMoqInput(input);
        var min = Number(input.getAttribute("min") || "10");
        if (Number(input.value || "0") < min) hasError = true;
      });
      if (checkoutButton && hasError) {
        event.preventDefault();
      }
    });
  });
})();
